export default __webpack_public_path__ + "static/media/Acolyte's Boots of the Nine Springs.b7608857.jpg";